module.exports = require("@material/icon-toggle/dist/mdc.iconToggle");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/icon-toggle/dist/mdc.iconToggle","commonjs2":"@material/icon-toggle/dist/mdc.iconToggle","commonjs":"@material/icon-toggle/dist/mdc.iconToggle","amd":"@material/icon-toggle/dist/mdc.iconToggle","umd":"@material/icon-toggle/dist/mdc.iconToggle"}
// module id = 36
// module chunks = 0